import { render, staticRenderFns } from "./mini-program-message-release.vue?vue&type=template&id=3204c877&scoped=true"
import script from "./mini-program-message-release.vue?vue&type=script&lang=js"
export * from "./mini-program-message-release.vue?vue&type=script&lang=js"
import style0 from "./mini-program-message-release.vue?vue&type=style&index=0&id=3204c877&prod&scoped=true&lang=css"
import style1 from "./mini-program-message-release.vue?vue&type=style&index=1&id=3204c877&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204c877",
  null
  
)

export default component.exports